<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
export default {
  data() {
    return {
      timeoutId: null,
      inactivityTimeout: 60 * 1000 * webNothingExit(), // 30分钟
    };
  },
  created() {
    this.initAutoLogout();
  },
  mounted() {},
  methods: {
    initAutoLogout() {
      let path = this.$route.path.toLowerCase();
      if (path != "/login" && path != "/dingding" && path != "/") {
        document.addEventListener("mousemove", this.resetTimer);
        document.addEventListener("keydown", this.resetTimer);
        this.resetTimer();
      } else {
        this.stopListener();
      }
    },
    resetTimer() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(this.logout, this.inactivityTimeout);
    },
    logout() {
      this.stopListener();
      this.$RemoveKey();
      this.$confirm("由于您长时间未进行操作，已超时自动退出登录", "提示", {
        showCancelButton: false,
        showClose: false,
        callback: (res) => {
          if (!regNull(dd) && dd.env.platform != "notInDingTalk") {
            this.$router.push({
              path: "/DingDing",
              query: {
                url: this.$router.history.current.fullPath,
              },
            });
          } else {
            this.$router.push({
              path: "/Login",
              query: {
                url: this.$router.history.current.fullPath,
              },
            });
          }
        },
      });
    },
    stopListener() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      document.removeEventListener("mousemove", this.resetTimer);
      document.removeEventListener("keydown", this.resetTimer);
    },
  },

  beforeDestroy() {
    this.stopListener();
  },
  watch: {
    $route() {
      this.initAutoLogout();
    },
  },
};
</script>

<style>
.el-card__header {
  padding: 18px 20px 6px 20px !important;
}
</style>
